/* eslint-disable jsx-a11y/no-autofocus */
import useTranslation from 'next-translate/useTranslation';
import { useFormContext } from 'react-hook-form';

// Components
import Button from '@/components/base/Button';
import Input from '@/components/base/Input';
import Label from '@/components/base/Label';
import PasswordField from '@/components/pages/signup/PasswordField';

// Libs
import { emailValid } from '@/lib/regex';

// Type
import { SignUpFormType } from '@/components/pages/signup/createAccount/SignUpForm';

const SignUpWithEmailForm = () => {
    const { t } = useTranslation('signup_funnel');
    const {
        register,
        formState: { errors, isSubmitting }
    } = useFormContext<SignUpFormType>();

    return (
        <>
            <div className="mb-5 mt-2">
                <Label required htmlFor="email">
                    {t('create_account.business_email')}
                </Label>
                <Input
                    type="email"
                    id="email"
                    name="email"
                    inputStyle="default_no_background"
                    error={errors?.email?.message}
                    placeholder={t('create_account.business_email_placeholder')}
                    autoFocus
                    {...register('email', {
                        required: t('errors:error_email_required'),
                        pattern: {
                            value: emailValid,
                            message: t('errors:error_email_email')
                        }
                    })}
                />
            </div>
            <PasswordField
                confirmPassword={true}
                withPlaceholder={true}
                inputStyle="default_no_background"
            />
            <Button isLoading={isSubmitting} id="signup-create-account-button" type="submit">
                {t('create_account.button_create_account')}
            </Button>
        </>
    );
};

export default SignUpWithEmailForm;
